import { Button } from "antd";
import styled from "styled-components";
import 'antd/dist/antd.min.css';

const styledButton = {
  Basic: styled(Button)``,
  Custom1: styled(Button)`
    background: #1890FF;
    width: 100%;
    height: 40px;
    border-radius: 2px;
    color: #ffffff;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  `,
};

export default styledButton;
